import { useState, useCallback } from 'react';

const useLeaveWorkspaceHooks = () => {
  const [leaveWorkspacePopupData, setLeaveWorkspacePopupData] = useState({
    show: false,
    id: null,
  });

  const handleCloseLeaveWorkspacePopup = () => {
    setLeaveWorkspacePopupData({ id: null, show: false });
  }

  const handleOpenLeaveWorkspacePopup = (id) => {
    setLeaveWorkspacePopupData({ id: id, show: true });
  }

  return { 
    leaveWorkspacePopupData,
    setLeaveWorkspacePopupData,
    handleCloseLeaveWorkspacePopup,
    handleOpenLeaveWorkspacePopup
  };
};

export default useLeaveWorkspaceHooks;